module.exports = __webpack_public_path__ + "static/media/by.80b2d2dd.svg";